// Permet de gérer les update de la db schedules pour les composants: AddPlayeur, DeletePlayeur, EditSchedulesModal, ConfirmationModal
import { updateDoc, doc, arrayRemove, arrayUnion, getDoc } from "firebase/firestore";
import { db } from "../config/firebase-config";

export async function firebaseUpdateSchedulesDb(
  uid,
  data,
  operationType,
  dataForExcel
) {
  const schedulesRef = doc(db, "schedules", uid);
  const scheduleSnap = await getDoc(schedulesRef);

  const operationMap = {
    arrayUnion: arrayUnion,
    arrayRemove: arrayRemove,
    editObject: (data) => data, // Vous pouvez définir une fonction anonyme pour l'opération "editObject"
  };
  const operationFunction = operationMap[operationType];

  if (operationType === "acceptInscription") {
    
      
      await updateDoc(schedulesRef, {
        acceptProposition: arrayUnion(data),
      });
    
  } else if (
    operationType === "arrayUnion" ||
    operationType === "arrayRemove"
  ) {
    {
      return await updateDoc(schedulesRef, {
        usersRegisted: operationFunction(
          operationType === "arrayUnion"
            ? {
                name: data,
                birthDay: dataForExcel?.birthDay,
                email: dataForExcel?.email,
                phone: dataForExcel?.phone,
              }
            : data
        ),
      });
    }
  } else {
    return await updateDoc(schedulesRef, {
      ...data,
    });
  }
}
